/**
 * @generated SignedSource<<9749fe775a5568f7b156f1489a4a0707>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type WidgetWeatherCondition = "BROKEN_CLOUDS" | "CLEAR_SKY" | "FEW_CLOUDS" | "MIST" | "RAIN" | "SCATTERED_CLOUDS" | "SHOWER_RAIN" | "SNOW" | "THUNDERSTORM";
import { FragmentRefs } from "relay-runtime";
export type WidgetWeatherConditionIcon_WeatherOccasion$data = {
  readonly condition: WidgetWeatherCondition;
  readonly " $fragmentType": "WidgetWeatherConditionIcon_WeatherOccasion";
};
export type WidgetWeatherConditionIcon_WeatherOccasion$key = {
  readonly " $data"?: WidgetWeatherConditionIcon_WeatherOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetWeatherConditionIcon_WeatherOccasion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetWeatherConditionIcon_WeatherOccasion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "condition",
      "storageKey": null
    }
  ],
  "type": "WidgetWeatherOccasion",
  "abstractKey": null
};

(node as any).hash = "fd9cd26a6496cf71b807bc8bc14444a1";

export default node;
